import { Clock, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { S1Logo } from "@/components/S1Logo";
import { useAuth } from "@/lib/auth";
import { useNavigate } from "react-router-dom";

export function PendingApprovalScreen() {
  const { signOut, user } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate("/login", { replace: true });
  };

  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-background p-4">
      <div className="w-full max-w-md space-y-4">
        <Card className="bg-card border-border">
          <CardContent className="p-8 text-center space-y-6">
            <div className="flex justify-center">
              <S1Logo variant="full" height={56} />
            </div>

            <div className="flex justify-center">
              <div className="relative">
                <div className="absolute inset-0 bg-primary/20 rounded-full blur-xl animate-pulse" />
                <div className="relative bg-primary/10 p-4 rounded-full">
                  <Clock className="h-10 w-10 text-primary" />
                </div>
              </div>
            </div>

            <div className="space-y-2">
              <h1 className="text-xl font-bold">Demande en cours d'examen</h1>
              <p className="text-sm text-muted-foreground">
                Ton inscription est bien reçue. Nous examinons ta demande et tu recevras un email
                dès que ton accès sera activé.
              </p>
            </div>

            <div className="rounded-lg bg-muted/50 p-4 text-left text-xs space-y-1">
              <p className="text-muted-foreground">Compte concerné :</p>
              <p className="font-medium">{user?.email}</p>
            </div>

            <Button variant="ghost" size="sm" className="gap-2" onClick={handleSignOut}>
              <LogOut className="h-3.5 w-3.5" />
              Se déconnecter
            </Button>
          </CardContent>
        </Card>

        <p className="text-center text-2xs text-muted-foreground">
          Une question ?{" "}
          <a
            href="mailto:contact@systeme1-immo.fr"
            className="hover:text-foreground underline-offset-2 hover:underline"
          >
            contact@systeme1-immo.fr
          </a>
        </p>
      </div>
    </div>
  );
}
